const state = {
  userInfo: { products: '' }, // 用户信息
  companyInfo: {
    logo: '',
    name: ''
  } // 公司信息信息
};

export default state;
